import React from 'react';

import classes from './TuvCertificateMessage.module.scss';

const TuvCertificateMessage = () => {
    return (
        <div className={classes.tuvCertificateMessage}>
            <p>
                Certificate provided by Zamann Pharma Support GmbH, an ISO 9001:2015 certified company for personnel qualification in the fields of Pharmacy, Medical Technology, and Quality Assurance.
                Certification body: TÜV SÜD
                Certificate Registration No.: 12 100 60610 TMS
            </p>
        </div>
    );
};

export default TuvCertificateMessage;